module.exports = __webpack_public_path__ + "assets/conEjeY.bcf8b5567a04b432f061b451e72e2e9d.svg";


//////////////////
// WEBPACK FOOTER
// ./img/conEjeY.svg
// module id = 917
// module chunks = 0